import { useMemo } from "react";
import useUiuxStore from "src/store/useUiuxStore";

export function usePUR2010_R01Modal() {
	const { setCodeSearchModalProps } = useUiuxStore();

	return useMemo(
		() => ({
			setCodeSearchModalProps,
		}),
		[setCodeSearchModalProps],
	);
}
